import React from "react";
import {
  SEO,
  PageLayout,
  Background,
  CallToActionBanner,
  ImageCollection,
  InternalLink,
  OutboundLink,
  Content,
  Reviews,
} from "@bluefin/components";
import { Grid, List, Button, Image, Header } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout
          hero={
            <Background columns={2} stackable={true} className={"home-hero"}>
              <Background.Image
                images={[
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/logo_jpeg_7FODhD4.png",
                ]}
              />
              <Background.Image
                images={getComponentFiles({
                  components: fishermanBusinessWebsitePage.components,
                  componentName: "HeroElement",
                })}
              />
            </Background>
          }
          subfooter={false}
          className={"home-page"}
        >
          <CallToActionBanner stackable={true} />
          <Grid
            stackable={true}
            className={"gallery-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <ImageCollection
                images={[
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/1_tTzlRJG.png",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/2_ZRigZpo.png",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/3_Fw2pV1h.png",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/4_LUn4H6a.png",
                ]}
                as={"carousel"}
                centered={true}
                cutUnevenRows={true}
                smartImageGrouping={false}
                disable={"none"}
                carouselOptions={{ autoScroll: true, autoScrollTime: 4000 }}
                header={""}
                numberOfRowDisplayItems={3}
              />
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            padded={true}
            columns={"2"}
            vertical-align={"middle"}
            centered={true}
            className={"custom-offering-section"}
          >
            <Grid.Column text-align={"left"}>
              <h2>Now Offering Dog Boarding & Daycare</h2>
              <em>From the team you already trust at Nails 2 Tails.</em>
              <p>
                At Nails 2 Tails Grooming, caring for pets has always been about
                more than just grooming—it’s about trust, comfort, and treating
                every dog like family. Because of that, we’re excited to
                introduce Paws & Pillows by Nails 2 Tails, our dedicated dog
                boarding and daycare facility.
              </p>
              <p />
              <p>
                Created in response to years of requests from our clients, Paws
                & Pillows gives pet parents a safe, clean, and loving place for
                their dogs to stay while they’re away. With supervised play,
                cozy overnight suites, and optional camera access for boarding
                guests, you can feel confident knowing your pup is happy and
                well cared for.
              </p>
              <List
                items={[
                  "Same trusted team.",
                  "Same commitment to care.",
                  "Now offering daycare and boarding, too.",
                ]}
              />
              <Button
                primary={true}
                as={InternalLink}
                to={"/meet-paws-pillows/"}
                content={"Learn More About Paws & Pillows"}
              />
              <Button
                primary={true}
                as={OutboundLink}
                to={
                  "https://booking.moego.pet/ol/PawsPillowsByNails2Tails/book?utm_medium=embed"
                }
                content={"Book Your Dog’s Stay"}
              />
            </Grid.Column>
            <Grid.Column>
              <Image
                src={
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/Dog_Boarding___Daycare_3.jpg"
                }
                centered={true}
                background={true}
              />
            </Grid.Column>
          </Grid>
          <Content
            stackable={true}
            className={"component-section-container about-section"}
          >
            <Content.Markup isMarkdown={false} textAlign={"center"} width={16}>
              <Header as={"h1"}>About Us</Header>
            </Content.Markup>
            <Content.Markup truncate={true} paragraphs={3} width={12}>
              {fishermanBusiness.aboutMarkdown}
            </Content.Markup>
          </Content>
          <ImageCollection
            images={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "ImageCollection",
              numToSelect: 2,
            })}
            as={"gallery"}
            centered={true}
            cutUnevenRows={true}
            smartImageGrouping={false}
            disable={"none"}
            header={""}
            numberOfRowDisplayItems={2}
          />
          <Grid
            stackable={true}
            className={"gallery-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <ImageCollection
                images={[
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image0.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image1.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image2.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image4.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image5.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image6.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image7.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image8.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image9.jpg",
                  "https://fisherman.gumlet.io/public/b2e5e97c-ce2d-4b86-a594-eced6c4c5629/image10.jpg",
                ]}
                as={"carousel"}
                centered={true}
                cutUnevenRows={true}
                smartImageGrouping={false}
                disable={"none"}
                carouselOptions={{ autoScroll: true, autoScrollTime: 4000 }}
                header={""}
                numberOfRowDisplayItems={4}
              />
            </Grid.Column>
          </Grid>
          <div className={"reviews-container"}>
            <Reviews
              reviews={fishermanBusiness.reviews.slice(0, 3)}
              as={"card"}
              buttonBasic={false}
              buttonSize={"medium"}
              centerHeader={true}
              cardInlinePhoto={"left"}
              header={"Customer Reviews"}
              imageCircular={false}
              imageSize={"small"}
              itemButtonFloat={false}
              itemCenterContent={false}
              itemsDivided={false}
              itemsPerRow={3}
              linkAs={"none"}
              onlyEvenRows={true}
              showImage={true}
              verticalItemAlign={"left"}
            />
            <Button
              to={"/about/"}
              primary={true}
              size={"large"}
              as={InternalLink}
            >
              See More
            </Button>
          </div>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      aboutMarkdown
      reviews {
        author
        text
        link
      }
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Home" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
